module.exports = __webpack_public_path__ + "media/assets/images/blog/aws_web_architecture-small-026d7b17213514d9a76c871cb27f24d6.png";